"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { normalizeSingleFilterFormData } from "@/helpers/request-helpers";
import { ITag } from "@/interfaces/tag.interface";
import { IFilter } from "@/types/filter.types";
import {
  GetRequestProps,
  PaginatedResponse,
  RequestPagination,
  RequestsBaseReturn,
} from "@/types/requests.types";

import tagService from "../../../services/tag.service";

export type UseGetTagsReturn = RequestsBaseReturn<PaginatedResponse<ITag> | null>;

export interface UseGetTagsProps extends RequestPagination, GetRequestProps {
  filters: IFilter<ITag>[];
  isPaused?: boolean;
}

type GetAllSwrParams = [string, number, number, IFilter<ITag>[]];

const useGetTags = ({
  pageNumber,
  pageSize,
  filters,
  isPaused = false,
}: UseGetTagsProps): UseGetTagsReturn => {
  const normalizedFilter = normalizeSingleFilterFormData(filters, "name");

  const {
    data = null,
    isValidating,
    error,
  } = useSWR<PaginatedResponse<ITag>, Error, GetAllSwrParams>(
    [SWR_KEYS.getTags, pageNumber, pageSize, normalizedFilter],
    ([, _pageNumber, _pageSize, _filters]) =>
      tagService.filter(_filters, {
        pageNumber: _pageNumber,
        pageSize: _pageSize,
      }),
    {
      revalidateOnFocus: false,
      isPaused: () => isPaused,
    }
  );

  const isLoading = isPaused ? false : isValidating;

  return { data, isLoading, error };
};

export default useGetTags;
